"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var styles = function styles(theme) {
  return {
    root: {
      margin: 0,
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    icon: {
      borderRadius: '50%',
      width: 16,
      height: 16,
      boxShadow: "inset 0 0 0 1px ".concat(_colors["default"].iconLight, ", inset 0 -1px 0 ").concat(_colors["default"].iconLight),
      'input:disabled ~ &': {
        background: _colors["default"].iconLight
      }
    },
    checkedIcon: {
      backgroundColor: _colors["default"].purple,
      boxShadow: 'none',
      '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""'
      }
    }
  };
};

exports.styles = styles;